import React, { useState, ChangeEvent } from "react";
import { Link, useHistory } from "react-router-dom";
import { replacePassword, forgotPasswordSendOtp } from "../_redux/authCrud";

function ErrorMessage({ text, }: { text: String, }) {
    return <div className="error invalid-feedback" style={{ display: 'block' }}>{text}</div>
}

export const ForgotPassword = () => {
    const history = useHistory();
    const [otpSentAndShowValidation, setOtpSentAndShowValidation] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [showEmailRequiredError, setShowEmailRequiredError] = useState(false)
    const [showEmailNotValidError, setShowEmailNotValidError] = useState(false)
    const [showEmailNotFoundError, setShowEmailNotFoundError] = useState(false)
    const [showOtpValidationError, setShowOtpValidationError] = useState(false)
    const [emailInputted, setEmailInputted] = useState('')
    const [otpInput, setOtpInput] = useState('')
    const [newPasswordInput, setNewPasswordInput] = useState('')
    const [confirmPasswordInput, setConfirmPasswordInput] = useState('')

    const passwordValidation = () => {
        if (!newPasswordInput) {
            return '';
        } else if (newPasswordInput !== confirmPasswordInput) {
            return 'Passwords must match';
        } else if (
            (!newPasswordInput.match(/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,15}$/))
        ) {
            return 'The password should be between 8 to 15 characters, contains at least one numeric digit and a special character';
        }
    }

    const backToEmailStep = () => {
        setOtpSentAndShowValidation(false)
        resetErrors()
    }

    const resetErrors = () => {
        setShowEmailNotValidError(false)
        setShowEmailRequiredError(false)
        setShowOtpValidationError(false)
    }

    const sendOtpToEmail = async () => {
        resetErrors()
        if (!emailInputted) {
            return setShowEmailRequiredError(true)
        } else if (!isEmailValid()) {
            return setShowEmailNotValidError(true)
        }
        setIsSubmitting(true)
        try {
            await forgotPasswordSendOtp({ email: emailInputted })
            setOtpSentAndShowValidation(true)
        } catch (error) {
            setShowEmailNotFoundError(true)
        }
        setIsSubmitting(false)
    }

    const validateOtpAndReplacePassword = async () => {
        resetErrors()
        setIsSubmitting(true)
        try {
            const replacePasswordRes = await replacePassword({ email: emailInputted, otp: otpInput, newPassword: newPasswordInput })
            setOtpSentAndShowValidation(replacePasswordRes.data)
            history.push('auth/login')
        } catch (error) {
            setShowOtpValidationError(true)
        }
        setIsSubmitting(false)
    }

    function onEmailChange(e: ChangeEvent<HTMLInputElement>) {
        setEmailInputted(e.target.value);
    }

    function onOtpChange(e: ChangeEvent<HTMLInputElement>) {
        setOtpInput(e.target.value);
    }

    function onNewPasswordChange(e: ChangeEvent<HTMLInputElement>) {
        setNewPasswordInput(e.target.value);
    }

    function onConfirmPasswordChange(e: ChangeEvent<HTMLInputElement>) {
        setConfirmPasswordInput(e.target.value);
    }

    const isEmailValid = () => {
        const splitEmail = emailInputted.split('@');
        if (splitEmail.length !== 2 || emailInputted[splitEmail[1] as any]) {
            return;
        }
        const emailRegex = /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/;
        return emailRegex.test(emailInputted);
    };

    return (
        <div className="login-form">
            <div className="text-center mb-10 mb-lg-20">
                <h3 className="font-size-h1">Forgotten Password?</h3>
            </div>
            <div className="form-group">
                {!otpSentAndShowValidation ? emailForOtpInput(onEmailChange, emailInputted, showEmailRequiredError,
                    showEmailNotValidError, showEmailNotFoundError)
                    : otpAndNewPasswordInputs(onOtpChange,
                        otpInput,
                        onNewPasswordChange,
                        newPasswordInput,
                        showOtpValidationError,
                        onConfirmPasswordChange,
                        confirmPasswordInput,
                        passwordValidation() as String,
                    )
                }
            </div>
            <div className="form-group d-flex flex-wrap flex-center">
                <button
                    id="kt_login_forgot_submit"
                    type="submit"
                    className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                    onClick={otpSentAndShowValidation ? validateOtpAndReplacePassword : sendOtpToEmail}
                    disabled={isSubmitting || !!passwordValidation()}
                >
                    Submit
                </button>
                {otpSentAndShowValidation ?
                    <button
                        onClick={backToEmailStep}
                        type="button"
                        id="kt_login_forgot_cancel"
                        className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                    >
                        Back
                    </button>
                    :
                    <Link to="/auth">
                        <button
                            type="button"
                            id="kt_login_forgot_cancel"
                            className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                        >
                            Cancel
                        </button>
                    </Link>
                }
            </div>
        </div>
    )
}

function otpAndNewPasswordInputs(onOtpChange: (e: ChangeEvent<HTMLInputElement>) => void,
    otpInput: string,
    onNewPasswordChange: (e: ChangeEvent<HTMLInputElement>) => void,
    newPasswordInput: string,
    showOtpValidationError: Boolean,
    onConfirmPasswordChange: (e: ChangeEvent<HTMLInputElement>) => void,
    confirmPasswordInput: any,
    passwordValidationError: String,
): React.ReactNode {
    return <>
        <input
            onChange={onOtpChange} value={otpInput}
            className="form-control form-control-solid h-auto py-5 px-6"
            type="email"
            placeholder="Enter the PIN you received by email" />
        <input
            onChange={onNewPasswordChange} value={newPasswordInput}
            className="form-control mt-5 form-control-solid h-auto py-5 px-6"
            type="password"
            placeholder="Enter new password" />
        <input
            onChange={onConfirmPasswordChange} value={confirmPasswordInput}
            className="form-control mt-5 form-control-solid h-auto py-5 px-6"
            type="password"
            placeholder="Confirm your password" />
        {
            showOtpValidationError ?
                <ErrorMessage text={'Something is wrong with your OTP code. Please try again'} />
                :
                passwordValidationError ?
                    <ErrorMessage text={passwordValidationError} />
                    :
                    <></>
        }
    </>;
}

function emailForOtpInput(onEmailChange: (e: ChangeEvent<HTMLInputElement>) => void,
    emailInputted: string,
    showEmailRequiredError: Boolean,
    showEmailNotValidError: Boolean,
    showEmailNotFoundError: Boolean) {
    return <>
        <input
            onChange={onEmailChange} value={emailInputted}
            className="form-control form-control-solid h-auto py-5 px-6"
            type="email"
            placeholder="Enter Email" />
        {showEmailRequiredError ?
            <ErrorMessage text={'Email is required'} />
            : showEmailNotValidError ?
                <ErrorMessage text={'Email is not valid'} />
                : showEmailNotFoundError ?
                    <ErrorMessage text={'Email was not found'} />
                    : <></>
        }
    </>
}
